{
	"Features 01": {
		"Feature 01": {
			"permission": "Admin",
			"textObject": "title: Misdemeanors\nimageDescription: legal documents spread around, in soft, dramatic courtroom lighting, representing misdemeanor law\ndescription: Misdemeanor charges are less severe criminal offenses typically punishable by fines, probation, community service, or a short jail sentence, usually lasting less than one year. They are less serious than felonies but can still have significant legal and personal consequences.",
			"translations": {},
			"type": "TextObject",
			"value": {
				"description": {
					"translations": {
						"en": "Misdemeanor charges are less severe criminal offenses typically punishable by fines, probation, community service, or a short jail sentence, usually lasting less than one year. They are less serious than felonies but can still have significant legal and personal consequences.",
						"en-US": "Misdemeanor charges are less severe criminal offenses typically punishable by fines, probation, community service, or a short jail sentence, usually lasting less than one year. They are less serious than felonies but can still have significant legal and personal consequences."
					},
					"value": "Misdemeanor charges are less severe criminal offenses typically punishable by fines, probation, community service, or a short jail sentence, usually lasting less than one year. They are less serious than felonies but can still have significant legal and personal consequences."
				},
				"imageDescription": {
					"translations": {
						"en": "legal documents spread around, in soft, dramatic courtroom lighting, representing misdemeanor law",
						"en-US": "legal documents spread around, in soft, dramatic courtroom lighting, representing misdemeanor law"
					},
					"value": "legal documents spread around, in soft, dramatic courtroom lighting, representing misdemeanor law"
				},
				"title": {
					"translations": {
						"en": "Misdemeanors",
						"en-US": "Misdemeanors"
					},
					"value": "Misdemeanors"
				}
			}
		},
		"Feature 01 Image": {
			"permission": "Admin",
			"translations": {},
			"type": "Image",
			"value": {
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/tj-moore.firebasestorage.app/o/uploads%2Fpractice%20areas%2FFeatures%2001%2FFeature%2001%20Image%2FDALL%C2%B7E%202025-02-20%2023.24.18.jpeg?alt=media&token=bf79effd-b731-4527-a28e-7ea049d24cf5",
				"formattedSize": "195.76 KB",
				"height": 1024,
				"name": "DALL·E 2025-02-20 23.24.18.jpeg",
				"path": "uploads/practice areas/Features 01/Feature 01 Image/DALL·E 2025-02-20 23.24.18.jpeg",
				"query": "?as=run",
				"size": 200461,
				"type": "image/jpeg",
				"updated": "2025-02-21T14:56:09.038Z",
				"width": 1792
			}
		},
		"Feature 02": {
			"permission": "Admin",
			"textObject": "title: Felonys\nimageDescription: a gavel, legal documents, and a pair of handcuffs under dramatic courtroom lighting\ndescription: Felonies encompass a wide range of crimes, from violent acts like murder and robbery to non-violent offenses such as drug trafficking and embezzlement.",
			"translations": {},
			"type": "TextObject",
			"value": {
				"description": {
					"translations": {
						"en": "Felonies encompass a wide range of crimes, from violent acts like murder and robbery to non-violent offenses such as drug trafficking and embezzlement.",
						"en-US": "Felonies encompass a wide range of crimes, from violent acts like murder and robbery to non-violent offenses such as drug trafficking and embezzlement."
					},
					"value": "Felonies encompass a wide range of crimes, from violent acts like murder and robbery to non-violent offenses such as drug trafficking and embezzlement."
				},
				"imageDescription": {
					"translations": {
						"en": "a gavel, legal documents, and a pair of handcuffs under dramatic courtroom lighting",
						"en-US": "a gavel, legal documents, and a pair of handcuffs under dramatic courtroom lighting"
					},
					"value": "a gavel, legal documents, and a pair of handcuffs under dramatic courtroom lighting"
				},
				"title": {
					"translations": {
						"en": "Felonys",
						"en-US": "Felonys"
					},
					"value": "Felonys"
				}
			}
		},
		"Feature 02 Image": {
			"permission": "Admin",
			"translations": {},
			"type": "Image",
			"value": {
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/tj-moore.firebasestorage.app/o/uploads%2Fpractice%20areas%2FFeatures%2001%2FFeature%2002%20Image%2FDALL%C2%B7E%202025-02-20%2023.48.46.jpeg?alt=media&token=54b8a548-993f-4b1a-830e-aae600d77fa8",
				"formattedSize": "285.21 KB",
				"height": 1024,
				"name": "DALL·E 2025-02-20 23.48.46.jpeg",
				"path": "uploads/practice areas/Features 01/Feature 02 Image/DALL·E 2025-02-20 23.48.46.jpeg",
				"query": "?as=run",
				"size": 292052,
				"type": "image/jpeg",
				"updated": "2025-02-21T15:27:36.664Z",
				"width": 1792
			}
		},
		"Feature 03": {
			"permission": "Admin",
			"textObject": "title: DUI/DWI\nimageDescription: A set of car keys on a wooden table next to an overturned glass with spilled alcohol, symbolizing DUI/DWI. A revoked driver’s license, gavel, and handcuffs represent the legal consequences. In the background, blurred car taillights fade into the night, emphasizing lost freedom.\ndescription: DUI, which stands for Driving Under the Influence, is a criminal offense where a person is charged for operating a motor vehicle while impaired by alcohol or drugs.",
			"translations": {},
			"type": "TextObject",
			"value": {
				"description": {
					"translations": {
						"en": "DUI, which stands for Driving Under the Influence, is a criminal offense where a person is charged for operating a motor vehicle while impaired by alcohol or drugs.",
						"en-US": "DUI, which stands for Driving Under the Influence, is a criminal offense where a person is charged for operating a motor vehicle while impaired by alcohol or drugs."
					},
					"value": "DUI, which stands for Driving Under the Influence, is a criminal offense where a person is charged for operating a motor vehicle while impaired by alcohol or drugs."
				},
				"imageDescription": {
					"translations": {
						"en": "A set of car keys on a wooden table next to an overturned glass with spilled alcohol, symbolizing DUI/DWI. A revoked driver’s license, gavel, and handcuffs represent the legal consequences. In the background, blurred car taillights fade into the night, emphasizing lost freedom.",
						"en-US": "A set of car keys on a wooden table next to an overturned glass with spilled alcohol, symbolizing DUI/DWI. A revoked driver’s license, gavel, and handcuffs represent the legal consequences. In the background, blurred car taillights fade into the night, emphasizing lost freedom."
					},
					"value": "A set of car keys on a wooden table next to an overturned glass with spilled alcohol, symbolizing DUI/DWI. A revoked driver’s license, gavel, and handcuffs represent the legal consequences. In the background, blurred car taillights fade into the night, emphasizing lost freedom."
				},
				"title": {
					"translations": {
						"en": "DUI/DWI",
						"en-US": "DUI/DWI"
					},
					"value": "DUI/DWI"
				}
			}
		},
		"Feature 03 Image": {
			"permission": "Admin",
			"translations": {},
			"type": "Image",
			"value": {
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/tj-moore.firebasestorage.app/o/uploads%2Fpractice%20areas%2FFeatures%2001%2FFeature%2003%20Image%2FDALL%C2%B7E%202025-02-20%2023.54.39.jpeg?alt=media&token=40bb9880-715c-4645-9e4d-11271f4b868f",
				"formattedSize": "246.22 KB",
				"height": 1024,
				"name": "DALL·E 2025-02-20 23.54.39.jpeg",
				"path": "uploads/practice areas/Features 01/Feature 03 Image/DALL·E 2025-02-20 23.54.39.jpeg",
				"query": "?as=run",
				"size": 252131,
				"type": "image/jpeg",
				"updated": "2025-02-21T15:28:28.070Z",
				"width": 1792
			}
		},
		"Feature 04": {
			"permission": "Admin",
			"textObject": "title: Probation Violations\nimageDescription: A wooden desk with neatly arranged legal documents, a checklist labeled 'Court-Ordered Responsibilities,' and a scheduled appointment notice. A pen rests on the checklist, symbolizing the need for compliance. A gavel and case files are nearby, representing legal oversight. In the background, a blurred courthouse setting suggests the formal nature of legal obligations.\ndescription: These charges occur when an individual who has been placed on probation fails to comply with the terms and conditions of their probationary sentence, such as missing required meetings with a probation officer, failing drug tests, or committing new crimes.",
			"translations": {},
			"type": "TextObject",
			"value": {
				"description": {
					"translations": {
						"en": "These charges occur when an individual who has been placed on probation fails to comply with the terms and conditions of their probationary sentence, such as missing required meetings with a probation officer, failing drug tests, or committing new crimes.",
						"en-US": "These charges occur when an individual who has been placed on probation fails to comply with the terms and conditions of their probationary sentence, such as missing required meetings with a probation officer, failing drug tests, or committing new crimes."
					},
					"value": "These charges occur when an individual who has been placed on probation fails to comply with the terms and conditions of their probationary sentence, such as missing required meetings with a probation officer, failing drug tests, or committing new crimes."
				},
				"imageDescription": {
					"translations": {
						"en": "A wooden desk with neatly arranged legal documents, a checklist labeled 'Court-Ordered Responsibilities,' and a scheduled appointment notice. A pen rests on the checklist, symbolizing the need for compliance. A gavel and case files are nearby, representing legal oversight. In the background, a blurred courthouse setting suggests the formal nature of legal obligations.",
						"en-US": "A wooden desk with neatly arranged legal documents, a checklist labeled 'Court-Ordered Responsibilities,' and a scheduled appointment notice. A pen rests on the checklist, symbolizing the need for compliance. A gavel and case files are nearby, representing legal oversight. In the background, a blurred courthouse setting suggests the formal nature of legal obligations."
					},
					"value": "A wooden desk with neatly arranged legal documents, a checklist labeled 'Court-Ordered Responsibilities,' and a scheduled appointment notice. A pen rests on the checklist, symbolizing the need for compliance. A gavel and case files are nearby, representing legal oversight. In the background, a blurred courthouse setting suggests the formal nature of legal obligations."
				},
				"title": {
					"translations": {
						"en": "Probation Violations",
						"en-US": "Probation Violations"
					},
					"value": "Probation Violations"
				}
			}
		},
		"Feature 04 Image": {
			"permission": "Admin",
			"translations": {},
			"type": "Image",
			"value": {
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/tj-moore.firebasestorage.app/o/uploads%2Fpractice%20areas%2FFeatures%2001%2FFeature%2004%20Image%2FDALL%C2%B7E%202025-02-21%2000.07.30.jpeg?alt=media&token=52a96419-1c37-48fc-8dbe-ab53b1e64a32",
				"formattedSize": "255.31 KB",
				"height": 1024,
				"name": "DALL·E 2025-02-21 00.07.30.jpeg",
				"path": "uploads/practice areas/Features 01/Feature 04 Image/DALL·E 2025-02-21 00.07.30.jpeg",
				"query": "?as=run",
				"size": 261433,
				"type": "image/jpeg",
				"updated": "2025-02-21T15:28:58.005Z",
				"width": 1792
			}
		},
		"gridSize": {
			"permission": "Admin",
			"translations": {
				"en-US": "2"
			},
			"type": "TextInput",
			"value": "2"
		},
		"index": 0,
		"theme": {
			"permission": "Admin",
			"translations": {
				"en-US": "light"
			},
			"type": "TextInput",
			"value": "light"
		},
		"title": {
			"permission": "Admin",
			"translations": {
				"en-US": "Practice Areas"
			},
			"type": "TextInput",
			"value": "Practice Areas"
		}
	},
	"Features Practice Areas": {
		"Feature 01": {
			"permission": "Admin",
			"textObject": "title: Misdemeanors\nimageDescription: legal documents spread around, in soft, dramatic courtroom lighting, representing misdemeanor law\ndescription: Misdemeanor charges are less severe criminal offenses typically punishable by fines, probation, community service, or a short jail sentence, usually lasting less than one year. They are less serious than felonies but can still have significant legal and personal consequences.",
			"translations": {},
			"type": "TextObject",
			"value": {
				"featureContent": {
					"translations": {},
					"value": "Misdemeanor charges are less severe criminal offenses typically punishable by fines, probation, community service, or a short jail sentence, usually lasting less than one year. They are less serious than felonies but can still have significant legal and personal consequences."
				},
				"title": {
					"translations": {},
					"value": "Misdemeanors"
				}
			}
		},
		"Feature 01 Image": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {},
					"value": "legal documents spread around, in soft, dramatic courtroom lighting, representing misdemeanor law"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/tj-moore.firebasestorage.app/o/uploads%2Fpractice%20areas%2FFeatures%20Practice%20Areas%2FFeature%2001%20Image%2FDALL%C2%B7E%202025-02-20%2023.24.18.jpeg?alt=media&token=2a857eee-0fa4-4119-a0e4-4425aec49ba6",
				"formattedSize": "195.76 KB",
				"height": 1024,
				"name": "DALL·E 2025-02-20 23.24.18.jpeg",
				"path": "uploads/practice areas/Features Practice Areas/Feature 01 Image/DALL·E 2025-02-20 23.24.18.jpeg",
				"query": "?as=run",
				"size": 200461,
				"type": "image/jpeg",
				"updated": "2026-04-04T03:34:50.934Z",
				"width": 1792
			}
		},
		"Feature 02": {
			"permission": "Admin",
			"textObject": "title: Felonys\nimageDescription: a gavel, legal documents, and a pair of handcuffs under dramatic courtroom lighting\ndescription: Felonies encompass a wide range of crimes, from violent acts like murder and robbery to non-violent offenses such as drug trafficking and embezzlement.",
			"translations": {},
			"type": "TextObject",
			"value": {
				"featureContent": {
					"translations": {},
					"value": "Felonies encompass a wide range of crimes, from violent acts like murder and robbery to non-violent offenses such as drug trafficking and embezzlement."
				},
				"title": {
					"translations": {},
					"value": "Felonys"
				}
			}
		},
		"Feature 02 Image": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {},
					"value": "a gavel, legal documents, and a pair of handcuffs under dramatic courtroom lighting"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/tj-moore.firebasestorage.app/o/uploads%2Fpractice%20areas%2FFeatures%20Practice%20Areas%2FFeature%2002%20Image%2FDALL%C2%B7E%202025-02-20%2023.48.46.jpeg?alt=media&token=97ad790e-5782-414c-9ac7-2b1ac11bbcc7",
				"formattedSize": "285.21 KB",
				"height": 1024,
				"name": "DALL·E 2025-02-20 23.48.46.jpeg",
				"path": "uploads/practice areas/Features Practice Areas/Feature 02 Image/DALL·E 2025-02-20 23.48.46.jpeg",
				"query": "?as=run",
				"size": 292052,
				"type": "image/jpeg",
				"updated": "2026-04-04T05:05:57.864Z",
				"width": 1792
			}
		},
		"Feature 03": {
			"permission": "Admin",
			"textObject": "title: DUI/DWI\nimageDescription: A set of car keys on a wooden table next to an overturned glass with spilled alcohol, symbolizing DUI/DWI. A revoked driver’s license, gavel, and handcuffs represent the legal consequences. In the background, blurred car taillights fade into the night, emphasizing lost freedom.\ndescription: DUI, which stands for Driving Under the Influence, is a criminal offense where a person is charged for operating a motor vehicle while impaired by alcohol or drugs.",
			"translations": {},
			"type": "TextObject",
			"value": {
				"featureContent": {
					"translations": {},
					"value": "DUI, which stands for Driving Under the Influence, is a criminal offense where a person is charged for operating a motor vehicle while impaired by alcohol or drugs."
				},
				"title": {
					"translations": {},
					"value": "DUI/DWI"
				}
			}
		},
		"Feature 03 Image": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {},
					"value": "A set of car keys on a wooden table next to an overturned glass with spilled alcohol, symbolizing DUI/DWI. A revoked driver’s license, gavel, and handcuffs represent the legal consequences. In the background, blurred car taillights fade into the night, emphasizing lost freedom."
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/tj-moore.firebasestorage.app/o/uploads%2Fpractice%20areas%2FFeatures%20Practice%20Areas%2FFeature%2003%20Image%2FDALL%C2%B7E%202025-02-20%2023.54.39.jpeg?alt=media&token=22b429bb-8fcc-4784-8b7d-0a8c8f9e20ba",
				"formattedSize": "246.22 KB",
				"height": 1024,
				"name": "DALL·E 2025-02-20 23.54.39.jpeg",
				"path": "uploads/practice areas/Features Practice Areas/Feature 03 Image/DALL·E 2025-02-20 23.54.39.jpeg",
				"query": "?as=run",
				"size": 252131,
				"type": "image/jpeg",
				"updated": "2026-04-04T05:06:48.412Z",
				"width": 1792
			}
		},
		"Feature 04": {
			"permission": "Admin",
			"textObject": "title: Probation Violations\nimageDescription: A wooden desk with neatly arranged legal documents, a checklist labeled 'Court-Ordered Responsibilities,' and a scheduled appointment notice. A pen rests on the checklist, symbolizing the need for compliance. A gavel and case files are nearby, representing legal oversight. In the background, a blurred courthouse setting suggests the formal nature of legal obligations.\ndescription: These charges occur when an individual who has been placed on probation fails to comply with the terms and conditions of their probationary sentence, such as missing required meetings with a probation officer, failing drug tests, or committing new crimes.",
			"translations": {},
			"type": "TextObject",
			"value": {
				"featureContent": {
					"translations": {},
					"value": "These charges occur when an individual who has been placed on probation fails to comply with the terms and conditions of their probationary sentence, such as missing required meetings with a probation officer, failing drug tests, or committing new crimes."
				},
				"title": {
					"translations": {},
					"value": "Probation Violations"
				}
			}
		},
		"Feature 04 Image": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {},
					"value": "A wooden desk with neatly arranged legal documents, a checklist labeled 'Court-Ordered Responsibilities,' and a scheduled appointment notice. A pen rests on the checklist, symbolizing the need for compliance. A gavel and case files are nearby, representing legal oversight. In the background, a blurred courthouse setting suggests the formal nature of legal obligations."
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/tj-moore.firebasestorage.app/o/uploads%2Fpractice%20areas%2FFeatures%20Practice%20Areas%2FFeature%2004%20Image%2FDALL%C2%B7E%202025-02-21%2000.07.30.jpeg?alt=media&token=253459b0-4cf5-47ea-b7da-96e653ad174c",
				"formattedSize": "255.31 KB",
				"height": 1024,
				"name": "DALL·E 2025-02-21 00.07.30.jpeg",
				"path": "uploads/practice areas/Features Practice Areas/Feature 04 Image/DALL·E 2025-02-21 00.07.30.jpeg",
				"query": "?as=run",
				"size": 261433,
				"type": "image/jpeg",
				"updated": "2026-04-04T05:07:29.121Z",
				"width": 1792
			}
		},
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"contentClass": {
					"translations": {},
					"value": "mx-2 sm:mx-4 py-8"
				},
				"featureContainerClass": {
					"translations": {},
					"value": "mx-auto border-8 border-primary rounded w-full text-center"
				},
				"featureContentClass": {
					"translations": {},
					"value": "p-8"
				},
				"featureTitleContainerClass": {
					"translations": {},
					"value": "w-full mt-4 mb-2"
				},
				"featuresContainerClass": {
					"translations": {},
					"value": "grid grid-cols-1 lg:grid-cols-2 gap-16"
				},
				"imageClass": {
					"translations": {},
					"value": "bottom-rounded-full"
				},
				"imageContainerClass": {
					"translations": {},
					"value": "w-full"
				}
			}
		},
		"index": 1,
		"order": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "04"
		}
	},
	"Features Your Rights": {
		"Feature 01": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"description": {
					"translations": {},
					"value": "## Your Rights. Your Future. Our Commitment.\n\n---\n\nWhen facing legal challenges, you need more than just an attorney; you need an experienced and relentless advocate. That’s where the Thomas J. Moore Criminal Law Firm steps in.\n\nWith over two decades of dedicated practice in Birmingham, Alabama, Thomas J. Moore has become a respected name in criminal defense. His experience spans a wide range of criminal cases, from DUI and drug offenses to white-collar crimes and more.\n\nWe understand that every case is unique, and every client deserves individual attention. At our firm, you’re not just a case number. We take the time to listen, understand your situation, and craft a personalized defense strategy that aligns with your best interests. We know what it takes to achieve results, and we’re ready to fight for you."
				}
			}
		},
		"Feature 02": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput"
		},
		"Feature 02 Image": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {},
					"value": "Lawyer holding glasses reading a book at a desk in his office"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/tj-moore.firebasestorage.app/o/uploads%2Fpractice%20areas%2FFeatures%20Your%20Rights%2FFeature%2002%20Image%2Fthe_biggest_mass_tort_cases_in_history.jpg?alt=media&token=f8a49fd7-84b2-45d3-a6af-10c5d95916ab",
				"formattedSize": "56.93 KB",
				"height": 600,
				"name": "the_biggest_mass_tort_cases_in_history.jpg",
				"path": "uploads/practice areas/Features Your Rights/Feature 02 Image/the_biggest_mass_tort_cases_in_history.jpg",
				"query": "?as=run",
				"size": 58297,
				"type": "image/jpeg",
				"updated": "2026-04-04T03:24:49.423Z",
				"width": 900
			}
		},
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"featureContainerClass": {
					"translations": {},
					"value": "w-full m-auto"
				},
				"featuresContainerClass": {
					"translations": {},
					"value": "grid grid-cols-1 lg:grid-cols-2 gap-2 sm:gap-4"
				},
				"imageClass": {
					"translations": {},
					"value": "m-auto border-8 border-primary rounded"
				},
				"imageContainerClass": {
					"translations": {},
					"value": "p-16"
				}
			}
		},
		"index": 2,
		"order": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "03"
		}
	},
	"PageBanner": {
		"bgImage": {
			"permission": "Admin",
			"translations": {},
			"type": "Image",
			"value": {
				"description": {
					"translations": {},
					"value": "Law book labeled practice areas with scales of justice and legal books in the background."
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/tj-moore.firebasestorage.app/o/uploads%2Fpractice%20areas%2FPageBanner%2FbgImage%2FPractice%20Areas%20Banner.jpg?alt=media&token=3ab6c968-51b6-49ea-99e7-a3a1af5dd9e1",
				"formattedSize": "76.56 KB",
				"height": 491,
				"name": "Practice Areas Banner.jpg",
				"path": "uploads/practice areas/PageBanner/bgImage/Practice Areas Banner.jpg",
				"query": "?as=run",
				"size": 78400,
				"type": "image/jpeg",
				"updated": "2025-02-21T14:48:40.910Z",
				"width": 1591
			}
		},
		"bgImageDescription": {
			"permission": "Admin",
			"translations": {
				"en-US": "A wooden desk with a gavel, an open law book, and four neatly arranged legal documents labeled 'Felonies,' 'Misdemeanors,' 'Parole Violations,' and 'DUI.' A pen rests on the documents, symbolizing legal action. The softly blurred background suggests a professional law office or courthouse setting with warm yet serious lighting."
			},
			"type": "TextArea",
			"value": "Justice Scales and a row of books with the top edge of a document that says practice areas"
		},
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"bgImageClass": {
					"translations": {},
					"value": "w-full"
				},
				"contentClass": {
					"translations": {},
					"value": "bg-base-300 inline-block p-2 sm:p-4 md:p-6 xl:p-8 rounded mx-2 sm:mx-4"
				}
			}
		},
		"index": 3,
		"order": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "02"
		},
		"subtitle": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "Criminal Lawyers Birmingham Office of Thomas Johnson Moore"
		},
		"title": {
			"permission": "Admin",
			"translations": {
				"en-US": "Practice Areas"
			},
			"type": "TextInput",
			"value": "Practice Areas"
		}
	},
	"PracticeAreas": {
		"index": 4
	},
	"SideBySide": {
		"description": {
			"permission": "Admin",
			"translations": {
				"en-US": "When facing legal challenges, you need more than just an attorney; you need an experienced and relentless advocate. That’s where the Thomas J. Moore Criminal Law Firm steps in.\n\nWith over two decades of dedicated practice in Birmingham, Alabama, Thomas J. Moore has become a respected name in criminal defense. His experience spans a wide range of criminal cases, from DUI and drug offenses to white-collar crimes and more.\n\nWe understand that every case is unique, and every client deserves individual attention. At our firm, you’re not just a case number. We take the time to listen, understand your situation, and craft a personalized defense strategy that aligns with your best interests. We know what it takes to achieve results, and we’re ready to fight for you."
			},
			"type": "TextArea",
			"value": "---\n\nWhen facing legal challenges, you need more than just an attorney; you need an experienced and relentless advocate. That’s where the Thomas J. Moore Criminal Law Firm steps in.\n\nWith over two decades of dedicated practice in Birmingham, Alabama, Thomas J. Moore has become a respected name in criminal defense. His experience spans a wide range of criminal cases, from DUI and drug offenses to white-collar crimes and more.\n\nWe understand that every case is unique, and every client deserves individual attention. At our firm, you’re not just a case number. We take the time to listen, understand your situation, and craft a personalized defense strategy that aligns with your best interests. We know what it takes to achieve results, and we’re ready to fight for you."
		},
		"flipped": {
			"permission": "Admin",
			"translations": {
				"en-US": "true"
			},
			"type": "TextInput",
			"value": "true"
		},
		"image": {
			"permission": "Admin",
			"translations": {},
			"type": "Image",
			"value": {
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/tj-moore.firebasestorage.app/o/uploads%2Fpractice%20areas%2FSideBySide%2Fimage%2Fthe_biggest_mass_tort_cases_in_history.jpg?alt=media&token=30694b89-2434-48e8-84d3-a2e7646adf3d",
				"formattedSize": "56.93 KB",
				"height": 600,
				"name": "the_biggest_mass_tort_cases_in_history.jpg",
				"path": "uploads/practice areas/SideBySide/image/the_biggest_mass_tort_cases_in_history.jpg",
				"query": "?as=run",
				"size": 58297,
				"type": "image/jpeg",
				"updated": "2025-02-21T15:06:11.797Z",
				"width": 900
			}
		},
		"index": 5,
		"title": {
			"permission": "Admin",
			"translations": {
				"en-US": "Your Rights. Your Future. Our Commitment."
			},
			"type": "TextInput",
			"value": "Your Rights. Your Future. Our Commitment."
		}
	}
}